import AddDocumentType from "Pages/PlannerView/AddDocumentType/AddDocumenType";
import UploadPlannerFile from "Pages/PlannerView/UploadPlannerFile/UploadPlannerFile";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "reactstrap";
import {
  BASE_URL,
  GET_DOCUMENT_TYPE,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import { UserInfoContext } from "Context/CommonContext";
import "../index.css";
import {
  EDP_BRANCH_CODE,
  academicPhase,
} from "utilFunctions/Constants/Constants";
import useMasterContext from "Context/MasterContext";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { Button, Col, Form, Input, Select } from "antd";
import HeadersComponent from "utilFunctions/shared/AntdSharedComponents/HeadersComponent";
import { StyledRow } from "Pages/MyBatchesAntd/MyBatchesHeaderAntd";
import MutlSelectAntdComponent from "utilFunctions/shared/AntdSharedComponents/MutlSelectAntdComponent";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
const ViewTableContainerDiv: any = styled<any>("div")`
  padding: ${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen) ? "20px 20px 20px 48px" : "0px"};
`;
function UploadPlannerHome() {
  const navigate = useNavigate();
  const { masters } = useMasterContext();
  const [form] = Form.useForm();
  const [filterState, setFilterState] = useState<any>({
    title: null,
    streamId: null,
    acadYearId: null,
    documentTypeId: null,
    classList: null,
    phaseList: null,
    subjectList: null,
  });
  const [docTypes, setDocTypes] = useState<selectInterface[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const userInfo = useContext<any>(UserInfoContext);
  const user_department: any = userInfo?.department;
  const isEDPDepartment: boolean = EDP_BRANCH_CODE.includes(user_department);
  const { screen }: any = useWindowSize();
  useEffect(() => {
    const uploadScreenOpenEvent = {
      event: "ag_planner_library_click_upload",
      EMPLOYEE_ID: userInfo?.employeeId ?? "",
    };
    console.log(
      "[GTM Track Event] ag_planner_library_click_upload:",
      uploadScreenOpenEvent
    );
    pushToDataLayerForGTM(uploadScreenOpenEvent);
  }, []);

  const { makeRequest: GetDocType } = useGetApi(
    (data) => {
      const newArray: selectInterface[] = [];
      data["data"].map((ele: any) => {
        newArray.push({
          label: ele.docType,
          key: ele.id,
          value: ele.id,
        });
      });
      setDocTypes(newArray);
    },
    (error) => {
      console.error(error);
    }
  );
  useEffect(() => {
    GetDocType(BASE_URL + GET_DOCUMENT_TYPE);
  }, []);
  const addNewDocumentTypeHandler = () => {
    GetDocType(BASE_URL + GET_DOCUMENT_TYPE);
    setFilterState({
      title: null,
      streamId: null,
      acadYearId: null,
      documentTypeId: null,
      classList: null,
      phaseList: null,
      subjectList: null,
    });
  };
  const toggle = () => setIsOpen(!isOpen);
  const addDocumentTypeHandler = () => {
    toggle();
  };
  const onChange = (field: any, val: any) => {
    setFilterState({
      ...filterState,
      [field]: val,
    });

    if (field == "classList") {
      form.setFieldsValue({
        classList: val,
      });
    }
  };
  const dropdownRender = (menu: React.ReactElement) => (
    <div>
      <div
        style={{ display: "flex", justifyContent: "space-between", padding: 0 }}
      >
        <Button type="link" onClick={addDocumentTypeHandler}>
          Add Document
        </Button>
      </div>
      {menu}
    </div>
  );
  return (
    <ViewTableContainerDiv screen={screen}>
      <AddDocumentType
        addNewDocumentTypeHandler={addNewDocumentTypeHandler}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        toggle={toggle}
      ></AddDocumentType>
      <HeadersComponent
        cardTitle={"Upload Files"}
        backButtonHandler={() => {
          navigate("/admin/planner", {
            replace: true,
            state: {
              selectedStudent: null,
            },
          });
        }}
      ></HeadersComponent>
      <Card className="mt-3">
        <Form
          layout={"vertical"}
          className="w-100 p-3"
          size="middle"
          form={form}
        >
          <StyledRow gutter={[10, 0]} screen={screen}>
            <Col xxl={6} xl={6} lg={6} md={12} sm={24} xs={24}>
              <Form.Item
                label="Document Title"
                name="title"
                rules={[
                  { required: true, message: "Please input Document Title!" },
                ]}
              >
                <Input
                  size="middle"
                  type={"text"}
                  onChange={(e) => onChange("title", e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={6} md={12} sm={24} xs={24}>
              <Form.Item
                label="Document Type"
                name="documentTypeId"
                rules={[
                  { required: true, message: "Please input Document Type" },
                ]}
              >
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  size="middle"
                  options={docTypes}
                  dropdownRender={dropdownRender}
                  onChange={(val) => onChange("documentTypeId", val)}
                />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={6} md={12} sm={24} xs={24}>
              <Form.Item
                label="Stream"
                name="streamId"
                rules={[{ required: true, message: "Please select stream" }]}
              >
                <Select
                  showSearch
                  defaultValue={
                    filterState.streamId ? filterState.streamId : null
                  }
                  style={{ width: "100%" }}
                  size="middle"
                  options={masters?.streams}
                  onChange={(val) => onChange("streamId", val)}
                />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={6} md={12} sm={24} xs={24}>
              <Form.Item
                label="Academic year"
                name={"acadYearId"}
                rules={[
                  {
                    required: true,
                    message: "Please select academic year",
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={
                    filterState.acadYearId ? filterState.acadYearId : null
                  }
                  style={{ width: "100%" }}
                  size="middle"
                  options={masters?.acadYears}
                  onChange={(val) => onChange("acadYearId", val)}
                />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={6} md={12} sm={24} xs={24}>
              <Form.Item
                label="Class"
                name={"classList"}
                rules={[{ required: true, message: "Please select Class" }]}
              >
                <MutlSelectAntdComponent
                  options={masters?.classes}
                  placeholder=""
                  form={form}
                  defaultValues={
                    filterState.classList ? filterState.classList : null
                  }
                  onChangeHandler={(val) => onChange("classList", val)}
                  name={"classList"}
                ></MutlSelectAntdComponent>
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={6} md={12} sm={24} xs={24}>
              <Form.Item label="Phase" name={"phaseList"}>
                <MutlSelectAntdComponent
                  options={academicPhase}
                  placeholder=""
                  form={form}
                  defaultValues={
                    filterState.phaseList ? filterState.phaseList : null
                  }
                  onChangeHandler={(val) => onChange("phaseList", val)}
                  name="phaseList"
                ></MutlSelectAntdComponent>
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={6} md={12} sm={24} xs={24}>
              <Form.Item label="Subject" name={"subjectList"}>
                <MutlSelectAntdComponent
                  options={userInfo?.subjectsListing}
                  placeholder=""
                  form={form}
                  defaultValues={
                    filterState.subjectList ? filterState.subjectList : null
                  }
                  onChangeHandler={(val) => onChange("subjectList", val)}
                  name="subjectList"
                ></MutlSelectAntdComponent>
              </Form.Item>
            </Col>
          </StyledRow>
        </Form>
        <UploadPlannerFile
          isEDPDepartment={isEDPDepartment}
          filterData={filterState}
          subjects={userInfo?.subjectsListing}
          stream={userInfo?.userStreams}
          acadYears={masters?.acadYears}
          classes={masters.classes}
          docTypes={docTypes}
        />
      </Card>
    </ViewTableContainerDiv>
  );
}

export default UploadPlannerHome;
